import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormBuilderFields',
  props: [
	"is_logged_in", "email", 'show_country', 'show_county', 'show_city', 
	'show_postal', 'show_tax', 'show_phone_no', 'show_company', 
	'show_anonymous_donation', 'enable_test_card_information', "strings",
	'use_form_builder', 'form_builder_config', 'formFields'
],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

// Field name mapping to store billing_fields keys
const fieldNameMap: Record<string, string> = {
	'first_name': 'first_name',
	'last_name': 'last_name',
	'email': 'email',
	'phone': 'phone',
	'company': 'company',
	'address': 'address',
	'city': 'city',
	'state': 'state',
	'zip': 'zip',
	'country': 'country',
	'tax': 'tax',
	'anonymous_donation': 'anonymous_donation'
};

// Computed properties
const useFormBuilder = computed(() => {
	return props.use_form_builder === true && (props.form_builder_config?.fields?.length > 0 || props.formFields?.length > 0);
});

const computedFormFields = computed(() => {
	if (!useFormBuilder.value) return [];
	return props.form_builder_config?.fields || [];
});

const displayFields = computed(() => {
	// Use formFields prop if provided, otherwise use form_builder_config
	if (props.formFields && Array.isArray(props.formFields) && props.formFields.length > 0) {
		return props.formFields;
	}
	if (computedFormFields.value && Array.isArray(computedFormFields.value) && computedFormFields.value.length > 0) {
		return computedFormFields.value;
	}
	return [];
});

// Get the store field value for a form builder field
const getStoreField = (field: any) => {
	const storeKey = fieldNameMap[field.name] || field.name;
	
	// Initialize the field in store if it doesn't exist
	if (!store.billing_fields.hasOwnProperty(storeKey)) {
		if (field.type === 'checkbox' || field.type === 'anonymous_donation') {
			store.billing_fields[storeKey] = false;
		} else {
			store.billing_fields[storeKey] = '';
		}
	}
	
	// Special handling for email if user is logged in
	if (field.name === 'email' && props.is_logged_in && props.email) {
		store.billing_fields.email = props.email;
	}
	
	return store.billing_fields[storeKey];
};

// Get store field value (for select fields)
const getStoreFieldValue = (field: any) => {
	const storeKey = fieldNameMap[field.name] || field.name;
	
	// Initialize the field in store if it doesn't exist
	if (!store.billing_fields.hasOwnProperty(storeKey)) {
		store.billing_fields[storeKey] = '';
	}
	
	return store.billing_fields[storeKey];
};

// Set store field value (for select fields)
const setStoreFieldValue = (field: any, value: any) => {
	const storeKey = fieldNameMap[field.name] || field.name;
	store.billing_fields[storeKey] = value;
};

// Get column class based on field type and position
const getFieldColumnClass = (field: any) => {
	// First name and last name should be half width
	if (field.name === 'first_name' || field.name === 'last_name') {
		return 'wpcm-col-md-6';
	}
	// All other fields are full width
	return 'wpcm-col-md-12';
};

// Set email on mount if user is logged in
onMounted(() => {
	if (props.is_logged_in && props.email) {
		store.billing_fields.email = props.email;
	}
});

const __returned__ = { store, props, fieldNameMap, useFormBuilder, computedFormFields, displayFields, getStoreField, getStoreFieldValue, setStoreFieldValue, getFieldColumnClass }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})